<template>
  <div>
    <section style="margin-right: 20px; margin-top: 10px">
      <div class="box box-danger">
        <div class="box-body">
          <h3>Resource Name: {{ this.partner }}</h3>
          <div v-if="this.isError" class="text-danger" style="padding: 10px; margin-bottom: 10px">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            {{ errorMessage || "Error occurred while loading the data." }}
          </div>

          <div
            v-if="this.manyRecordsAlert"
            class="alert alert-warning alert-dismissible"
            id="many-records-alert"
          >
            <button
              type="button"
              class="close"
              @click="this.closeManyRecsAlert"
              aria-hidden="true"
            >
              &times;
            </button>
            <i class="fa fa-exclamation-triangle"></i>
            <strong>Information!</strong>
            <p>
              The table is restricted to render up to 100,000 records. To fetch
              all the records, please contact technical team.
            </p>
          </div>

          <div v-if="this.data == null || this.data.length == 0">
            <!-- Empty state with consistent layout -->
            <div
              class="text-center"
              style="
                padding: 40px 20px;
                background-color: #f9f9f9;
                border: 1px solid #ddd;
                border-radius: 4px;
              "
            >
              <i
                class="fa fa-table fa-3x text-muted"
                style="margin-bottom: 20px"
              ></i>
              <h4 class="text-muted">No Usage Data Found</h4>
              <p class="text-muted">
                No usage records match your search criteria.<br />
                Try adjusting your filters or selecting a different date range.
              </p>
              <div class="text-muted" style="font-size: 12px; margin-top: 15px">
                <i class="fa fa-info-circle"></i>
                Broader search criteria may take longer to process
              </div>
            </div>

            <!-- Show table structure for consistency -->
            <div style="margin-top: 20px; opacity: 0.6">
              <div class="btn-group btn-group-sm" style="margin-bottom: 10px">
                <button class="btn btn-success btn-xs" disabled>
                  <i class="fa fa-file-excel-o"></i> Excel
                </button>
                <button class="btn bg-primary btn-xs" disabled>
                  <i class="fa fa-file-pdf-o"></i> PDF
                </button>
                <button class="btn btn-warning btn-xs" disabled>
                  <i class="fa fa-print"></i> Print
                </button>
                <button class="btn btn-danger btn-xs" disabled>
                  <i class="fa fa-copy"></i> Copy
                </button>
                <button class="btn btn-primary btn-xs" disabled>
                  <i class="fa fa-envelope"></i> Send Email
                </button>
              </div>

              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>IP Address</th>
                    <th>Total page views</th>
                    <th>Paid page views</th>
                    <th>Free page views</th>
                    <th>Sessions</th>
                    <th>Turnaways</th>
                    <th>Party Name</th>
                    <th>Partner</th>
                    <th>Month/Year</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      colspan="9"
                      class="text-center text-muted"
                      style="padding: 20px"
                    >
                      No data available
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-show="this.data != null && this.data.length > 0">
            <table
              v-if="!this.isError"
              :id="tableId"
              class="table table-bordered table-striped"
            >
              <tfoot>
                <tr>
                  <th>Total</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div v-if="this.isLoading" class="overlay">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UsageFilter from "./UsageFilter";
import axios from "axios";
import XLSX from "xlsx-js-style";
import { generateExcelFile, convertToCSV } from "../../../utils/exportUtils";

export default {
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      tableRef: null,
      tableId:
        "ID" + Math.floor(Math.random() * (1000 - 1 + 1)) + 1 + Date.now(),
      tableColumns: [
        {
          data: "ip",
          title: "IP Address",
          type: "string",
          render: null,
        },
        {
          data: "total_views",
          title: "Total page views",
          type: "number",
          render: null,
        },
        {
          data: "paid_content_count",
          title: "Paid page views",
          type: "number",
          render: null,
        },
        {
          data: "paid_content_count",
          title: "Free page views",
          type: "number",
          render: function (data, type, row) {
            return row.total_views - row.paid_content_count;
          },
        },
        {
          data: "session_count",
          title: "Sessions",
          type: "number",
          render: null,
        },
        {
          data: "total_turnaways",
          title: "Turnaways",
          type: "number",
          render: null,
        },
        {
          data: "partyName",
          title: "Party Name",
          type: "string",
          render: null,
        },
        {
          data: "partnerId",
          title: "Partner",
          type: "string",
          render: null,
        },
        {
          data: "month",
          title: "Month/Year",
          type: "string",
          render: function (data, type, row) {
            return row.month + "/" + row.year;
          },
        },
      ],

      partner: "",
    };
  },
  components: {
    appFilter: UsageFilter,
  },
  computed: {
    ...mapGetters("login", ["loggedInUser"]),
    ...mapGetters("usage", [
      "data",
      "filter",
      "isError",
      "errorMessage",
      "isLoading",
      "manyRecordsAlert",
    ]),
  },
  watch: {
    filter: {
      handler: function (val, oldVal) {
        this.partner = val.partner;
        if (val.partner == "tair") {
          this.partner = "TAIR";
        }
      },
      deep: true,
    },
    // data: {
    //   handler: function (val, oldVal) {
    //     console.log(val);
    //   },
    //   deep: true
    // },
  },
  mounted() {
    this.buildTable();
    this.firstName = this.loggedInUser.firstName;
    this.lastName = this.loggedInUser.lastName;
    this.email = this.loggedInUser.username;
  },
  methods: {
    // ...mapActions({
    //   stateUsageSetTableRef: types.USG_ACTION_TABLE_REF,
    //   stateUsageSetTooManyRecsAlert: types.USG_ACTION_MANY_RECORDS_ALERT,
    // }),
    closeManyRecsAlert() {
      this.stateUsageSetTooManyRecsAlert(false);
    },
    convertFromDateFormat(date) {
      var inputDate = date;
      var month = parseInt(inputDate.slice(0, 2)) - 1;
      var year = parseInt(inputDate.slice(3));

      var dateObj = new Date(year, month, 1);

      var monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      var formattedDate =
        monthNames[dateObj.getMonth()] +
        " " +
        dateObj.getDate() +
        ", " +
        dateObj.getFullYear();

      // console.log(formattedDate); // Outputs: "January 1, 2022" for input "01/2022"
      return formattedDate;
    },
    convertToDateFormat(date) {
      var inputDate = date; //"012022"
      var month = parseInt(inputDate.slice(0, 2)) - 1;
      var year = parseInt(inputDate.slice(3));

      var dateObj = new Date(year, month + 1, 0);

      var monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      var formattedDate =
        monthNames[dateObj.getMonth()] +
        " " +
        dateObj.getDate() +
        ", " +
        dateObj.getFullYear();

      // console.log(formattedDate); // Outputs: "January 31, 2022" for input "01/2022"
      return formattedDate;
    },
    buildTable() {
      // Capture Vue instance context for use inside button callbacks
      const vueInstance = this;

      this.tableRef = $("#" + this.tableId).DataTable({
        destroy: true,
        deferRender: true,
        aoColumns: this.tableColumns,
        paging: true,
        lengthChange: true,
        searching: true,
        ordering: true,
        info: true,
        autoWidth: false,
        dom: '<"top"Bt><"bottom"<"row"<"col-md-6 ln1"il><"col-md-6 pull-right"p>>>',
        oLanguage: { sSearch: '<i class="fa fa-search text-primary"></i>' },
        footerCallback: function (row, data, start, end, display) {
          const api = this.api();

          // Calculate totals for numeric columns (for all entries)
          const totalViews = api
            .column(1)
            .data()
            .reduce((a, b) => a + b, 0);
          const paidViews = api
            .column(2)
            .data()
            .reduce((a, b) => a + b, 0);
          // Free views must be calculated, not summed from column data
          // because column 3's data property is 'paid_content_count', not the computed value
          const freeViews = totalViews - paidViews;
          const sessions = api
            .column(4)
            .data()
            .reduce((a, b) => a + b, 0);
          const turnaways = api
            .column(5)
            .data()
            .reduce((a, b) => a + b, 0);

          // Update footer cells
          const footer = $(api.table().footer());
          const footerCells = footer.find("th");

          $(footerCells[0]).html("<strong>Total (All Records)</strong>");
          $(footerCells[1]).html(
            "<strong>" + totalViews.toLocaleString() + "</strong>"
          );
          $(footerCells[2]).html(
            "<strong>" + paidViews.toLocaleString() + "</strong>"
          );
          $(footerCells[3]).html(
            "<strong>" + freeViews.toLocaleString() + "</strong>"
          );
          $(footerCells[4]).html(
            "<strong>" + sessions.toLocaleString() + "</strong>"
          );
          $(footerCells[5]).html(
            "<strong>" + turnaways.toLocaleString() + "</strong>"
          );
        },
        buttons: [
          {
            extend: "excelHtml5",
            text: '<i class="fa fa-file-excel-o"></i> Excel',
            className: "btn btn-success btn-xs",
            action: function (e, dt, node, config) {
              const exportData = dt.buttons.exportData({
                orthogonal: "export",
                columns: ":visible",
              });

              try {
                const { workbook, filename } = generateExcelFile(exportData, {
                  startDate: vueInstance.filter.dateFrom,
                  endDate: vueInstance.filter.dateTo,
                  partyName: vueInstance.filter.partyName,
                  partnerName: vueInstance.filter.partner,
                });

                XLSX.writeFile(workbook, filename);
              } catch (error) {
                console.error("Error generating Excel file:", error);
                alert(error.message || "Error generating Excel file.");
              }
            },
          },
          {
            extend: "pdf",
            text: '<i class="fa fa-file-pdf-o"></i> PDF',
            className: "btn bg-primary btn-xs",
          },
          {
            extend: "print",
            text: '<i class="fa fa-print"></i> Print',
            className: "btn btn-warning btn-xs",
          },
          {
            extend: "copy",
            text: '<i class="fa fa-copy"></i> Copy',
            className: "btn btn-danger btn-xs",
          },
          {
            text: '<i class="fa fa-envelope"></i> Send Email',
            className: "btn btn-primary btn-xs",
            action: async (e, dt, node, config) => {
              var startDate = this.filter.dateFrom;
              var endDate = this.filter.dateTo;
              var inputEmail = prompt(
                "Enter email address you want the report emailed to:",
                this.email
              );
              if (inputEmail == null || inputEmail == "") {
                return;
              }

              const exportData = dt.buttons.exportData();
              // const csvContent = convertToCSV(exportData); // Remove CSV conversion

              // Generate Excel file
              const options = {
                startDate: this.filter.dateFrom,
                endDate: this.filter.dateTo,
                partyName: this.filter.partyName,
                partnerName: this.partner,
              };
              const { workbook, filename } = generateExcelFile(
                exportData,
                options
              );

              // Convert workbook to base64
              const wbout = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "base64",
              });

              try {
                await axios.post("/email/sendReportEmail", {
                  email: inputEmail,
                  // csvContent: csvContent, // Remove csvContent
                  xlsxContentBase64: wbout, // Add base64 content
                  filename: filename, // Add filename
                  userFirstName: this.firstName,
                  startDate: startDate,
                  endDate: endDate,
                });

                alert(
                  "Email sent to " +
                    inputEmail +
                    "! Please wait up to 5 minutes for email to arrive in your inbox."
                );
              } catch (error) {
                console.error("Error sending email:", error);
                // Provide more specific error feedback if possible
                const errorMessage =
                  (error.response && error.response.data) ||
                  error.message ||
                  "Error sending email. Please try again.";
                alert(errorMessage);
              }
            },
          },
        ],
      });
      this.$store.dispatch("usage/setTableRef", this.tableRef);

      $("div.dataTables_filter input").css({
        display: "inline-block",
        border: "1px solid #3b8ab8",
        padding: "5px",
      });
      $("div.dataTables_filter input").attr("placeholder", "Quick search...");
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/paywall/usage/UsageResult.vue